import React from 'react'

export default function TimerCountdownDisplay({ timerState, isDecision, daysRemaining, isBoardMember, paused, applicantWorking }) {
  if (!timerState) return null

  // TODO: when timerState === 'expired', product to decide:
  //   freeze at 0 (current) vs. count up as "X days overdue"
  // Clamped at 0 for every state, not just 'expired': a decision issued past its deadline
  // freezes a negative count, and a recess-tolled deadline inside the window can produce
  // one too. A countdown never reads below zero.
  const days = timerState === 'expired' ? 0 : Math.max(0, daysRemaining ?? 0)

  const isFrozen = ['cleared', 'inactive'].includes(timerState)
  // "last day!" belongs on the calendar day the timer is due — daysRemaining 0 with the
  // timer still running, since the deadline is end of that day. (The day before shows "1
  // day".) Must stay in lockstep with the `last-day` wrapper class in the role plugins.
  const isLastDay = timerState === 'expiring_soon' && days <= 0

  if (isLastDay && (!isBoardMember || isDecision)) {
    return (
      <div className="timer-countdown-display timer-countdown-display--last-day">
        <i className="fal fa-alarm-exclamation" />
        <span className="timer-countdown-display__last-day-label">last day!</span>
      </div>
    )
  }

  // Board member during the acknowledgment phase while the applicant is working on a
  // resubmission: there's no active ack timer (the timeline is on hold), so show a paused
  // alarm rather than a countdown or the generic frozen snooze.
  if (isBoardMember && !isDecision && applicantWorking) {
    return (
      <div className="timer-countdown-display timer-countdown-display--paused">
        <i className="fal fa-alarm-minus dome-color-accent" style={{ fontSize: '32px' }} />
      </div>
    )
  }

  const isRedState = timerState === 'expiring_soon' || timerState === 'expired'
  const isPaused = paused && !isRedState

  const classes = [
    'timer-countdown-display',
    isFrozen && 'timer-countdown-display--frozen',
    isPaused && 'timer-countdown-display--paused'
  ].filter(Boolean).join(' ')

  return (
    <div className={classes}>
      {isFrozen && !isDecision ? (
        <i className='fal fa-alarm-snooze dome-color-accent' style={{fontSize: '32px'}} />
      ) : (
        <>
          <span className="timer-countdown-display__number">{days}</span>
          <span className="timer-countdown-display__label">{days === 1 ? 'day' : 'days'}</span>
        </>
      )}
    </div>
  )
}
